import styled from "styled-components";

export const UnstyledListItemStyled = styled.li`
    display: inline-block;
    margin: 0rem;
    padding: 0rem;
    list-style-type: none;
`;
